import { useRef, useState } from 'react';
import { useIsomorphicLayoutEffect, useMount } from 'react-use';

export function useMounted() {
  const [documentMounted, setDocumentMounted] = useState(false);

  useIsomorphicLayoutEffect(() => {
    setDocumentMounted(true);
  }, []);

  return documentMounted;
}

export function useMountEffect(fn: () => void) {
  const firedRef = useRef(false);
  useMount(() => {
    if (firedRef.current) return;
    firedRef.current = true;
    fn();
  });
}
